
import { defineComponent, onMounted, ref, watch } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import VFacebookLogin from "vue-facebook-login-component-next";
/* eslint-disable */
import { getGoogleUrl } from "@/utils/getGoogleUrl";
import axios from "axios";
import { el } from "@fullcalendar/core/internal-common";
const formLogin = ref({
  thaID: false,
  idCard: "",
  firstName: "",
  lastName: "",
  prefix: "",
});
export default defineComponent({
  name: "sign-in",
  components: {
    Field,
    Form,
    ErrorMessage,
    VFacebookLogin,
  },
  data() {
    return {
      passwordFieldType: "password",
    };
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const submitButton = ref<HTMLButtonElement | null>(null);
    const route = useRoute();
    const rememberMe = ref(!!localStorage.getItem("rememberMe"));
    const initialValues = ref({
      username: localStorage.getItem("savedUsername") || "",
      password: localStorage.getItem("savedPassword") || "",
    });
    watch(
      () => route.path,
      () => {
        if (route.query && route.query.code && route.query.state == "DEDE") {
          getTokenThaiID(route.query.code, route.query.state);
        } else if (
          route.query &&
          route.query.code &&
          route.query.state != "DEDE"
        ) {
          getAccessToken(route.query.code);
        } else if (route.query && route.query.result) {
          getTokenOIDC(route.query.result);
        }
      },
    );
    const getUserInfo = (access_token) => {
      axios
        .get(`https://openidconnect.googleapis.com/v1/userinfo`, {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        })
        .then(async (response) => {
          // console.log(response.data);
          await store.dispatch(Actions.LOGIN, response.data);
          const [errorName] = Object.keys(store.getters.getErrors);
          const error = store.getters.getErrors[errorName];
           const adminRole = store.getters.currentUserAdminRole;
          // console.log(store.state.AuthModule.user);

          // console.log(error);
          if (!error) {
            Swal.fire({
              text: "เข้าสู่ระบบสำเร็จ!",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(function() {
              // console.log(router);
              // setTimeout(() => {
              //   localStorage.setItem("reloaded", "1");
              //   window.location.href ="/home"
              // }, 1000);
             if (adminRole == 4) {
            router.push({ name: "certificate-approve" });
          } else {
            router.push({ name: "home" });
          }
            });
          } else {
            Swal.fire({
              text: error,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "ลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          // console.log(error);
          Swal.fire({
            text: error,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    };
    const getAccessToken = (code) => {
      axios
        .post(
          `https://oauth2.googleapis.com/token?code=${code}&client_id=${process.env.VUE_APP_GOOGLE_CLIENT_ID}&client_secret=${process.env.VUE_APP_GOOGLE_CLIENT_SECRET}&redirect_uri=${process.env.VUE_APP_GOOGLE_REDIRECT_URL}&grant_type=${process.env.VUE_APP_GOOGLE_GRANT_TYPE}`,
        )
        .then((response) => {
          // console.log(response.data);
          getUserInfo(response.data.access_token);
        })
        .catch((error) => {
          // console.log(error);
          Swal.fire({
            text: error,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    };
    // if (route.query && route.query.code && formLogin.value.thaID != true) {
    //   // console.log(route.query.code);
    //   getAccessToken(route.query.code);
    // }
    const loginFacebook = (user) => {
      // console.log(user.authResponse.accessToken);
      axios
        .get(
          `https://graph.facebook.com/me?fields=id,picture,email,first_name,gender,last_name,name`,
          {
            headers: {
              Authorization: `Bearer ${user.authResponse.accessToken}`,
            },
          },
        )
        .then(async (response) => {
          // console.log(response.data);
          await store.dispatch(Actions.LOGIN, response.data);
          const [errorName] = Object.keys(store.getters.getErrors);
          const error = store.getters.getErrors[errorName];
          // console.log(store.state.AuthModule.user);
          // console.log(error);
          if (!error) {
            Swal.fire({
              text: "เข้าสู่ระบบสำเร็จ!",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(function() {
              router.push({ name: "home" });
            });
          } else {
            Swal.fire({
              text: error,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "ลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          // console.log(error);
          Swal.fire({
            text: error,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    };
    //Create form validation object
    const login = Yup.object().shape({
      username: Yup.string()
        // .email()
        .required("กรุณากรอกบัญชีผู้ใช้งาน"),
      password: Yup.string()
        .min(4)
        .required("กรุณากรอกรหัสผ่าน"),
    });

    //Form submit function
    const onSubmitLogin = async (values) => {
      // console.log(values);
      Swal.fire({
        title: "กำลังดำเนินการ...",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      // Clear existing errors
      // store.dispatch(Actions.LOGOUT);

      if (submitButton.value) {
        // eslint-disable-next-line
        submitButton.value!.disabled = true;
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
      }

      // Save or clear remember me
      if (rememberMe.value) {
        localStorage.setItem("rememberMe", "1");
        localStorage.setItem("savedUsername", values.username);
        localStorage.setItem("savedPassword", values.password);
      } else {
        localStorage.removeItem("rememberMe");
        localStorage.removeItem("savedUsername");
        localStorage.removeItem("savedPassword");
      }

      // Send login request
      await store.dispatch(Actions.LOGIN, values);
      const [errorName] = Object.keys(store.getters.getErrors);
      const error = store.getters.getErrors[errorName]; 
      const adminRole = store.getters.currentUserAdminRole;
      // console.log(store.state.AuthModule.user);

      // console.log(error);
      if (!error) {
        // Swal.fire({
        //   text: "เข้าสู่ระบบสำเร็จ!",
        //   icon: "success",
        //   buttonsStyling: false,
        //   confirmButtonText: "ตกลง",
        //   customClass: {
        //     confirmButton: "btn fw-semobold btn-light-primary",
        //   },
        // }).then(function() {
        //   localStorage.setItem("reloaded", "1");
        // router.push({ name: "home" });
        // });
        Swal.close();
       if (adminRole == 4) {
            router.push({ name: "certificate-approve" });
          } else {
            router.push({ name: "home" });
          }
      } else {
        Swal.fire({
          text: error,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "ลองใหม่ภายหลัง!",
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
      }

      //Deactivate indicator
      submitButton.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
      submitButton.value!.disabled = false;
    };

    onMounted(() => {
      store.dispatch(Actions.REMOVE_BODY_ATTRIBUTE, {
        qulifiedName: "style",
      });
      if (route.query && route.query.code && route.query.state == "DEDE") {
        getTokenThaiID(route.query.code, route.query.state);
      } else if (
        route.query &&
        route.query.code &&
        route.query.state != "DEDE"
      ) {
        getAccessToken(route.query.code);
      } else if (route.query && route.query.result) {
        getTokenOIDC(route.query.result);
      }
    });

    store.dispatch(Actions.ADD_BODY_ATTRIBUTE, {
      qulifiedName: "style",
      value: "background-image: url(media/patterns/header-bg.jpg)",
    });
    const onCallBackLoginThaiID = async () => {
      formLogin.value.thaID = true;
      window.location.href = `${process.env.VUE_APP_DOMAIN_THAIID}oauth2/auth/?response_type=${process.env.VUE_APP_DOMAIN_THAIID_RESPONSE_TYPE}&client_id=${process.env.VUE_APP_DOMAIN_THAIID_CLIENT_ID}&redirect_uri=${process.env.VUE_APP_DOMAIN_THAIID_REDIRECT_URI}&scope=${process.env.VUE_APP_DOMAIN_THAIID_SCOPE}&state=DEDE`;
    };
    const getTokenThaiID = (code, state) => {
      console.log("getTokenThaiID");
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getTokenThaiId?code=" +
            code +
            "&state=" +
            state,
        )
        .then((res) => {
          if (res.data.code == 200) {
            formLogin.value.idCard =
              res.data.data.pid && res.data.data.pid != undefined
                ? res.data.data.pid
                : "";
            formLogin.value.firstName =
              res.data.data.given_name && res.data.data.given_name != undefined
                ? res.data.data.given_name
                : "";
            formLogin.value.lastName =
              res.data.data.family_name &&
              res.data.data.family_name != undefined
                ? res.data.data.family_name
                : "";
            formLogin.value.prefix =
              res.data.data.titleTh && res.data.data.titleTh != undefined
                ? res.data.data.titleTh
                : "";
            formLogin.value.thaID = true;
            onSubmitLoginThaID();
          } else {
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              html: `${res.data.message}<br>หมายเหตุ : การเข้าสู่ระบบด้วย ThaID จำเป็นต้องเข้าสู่ระบบด้วยบัญชีผู้ใช้งานก่อน 1 ครั้ง ถึงจะสามารถใช้งานฟีเจอร์นี้ได้`,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            }).then(() => {
              Swal.close();
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text:
              "ไม่สามารถเข้าสู่ระบบ ThaID ได้ เนื่องจากไม่พบผู้ใช้งานท่านนี้",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          }).then(() => {
            Swal.close();
          });
        });
    };
    const onCallBackLoginOIDC = () => {
      window.location.href = `${process.env.VUE_APP_API_URL}/oidc/dede/login`;
    };
    const getTokenOIDC = async (result) => {
      const oidcResult = await store.dispatch(Actions.LOGIN_OIDC, result);
      if (oidcResult?.notFound) {
        const profile = oidcResult.profile || {};
        router.push({
          name: "sign-up",
          query: {
            sub: profile.sub ? encodeURIComponent(profile.sub) : undefined,
            givenName: profile.givenName
              ? encodeURIComponent(profile.givenName)
              : undefined,
            familyName: profile.familyName
              ? encodeURIComponent(profile.familyName)
              : undefined,
            name: profile.name ? encodeURIComponent(profile.name) : undefined,
            email: profile.email
              ? encodeURIComponent(profile.email)
              : undefined,
          },
        });
        return;
      }
      const [errorName] = Object.keys(store.getters.getErrors);
      const error = store.getters.getErrors[errorName];
      const adminRole = store.getters.currentUserAdminRole;
      if (!error) {
        Swal.fire({
          title: "กำลังเข้าสู่ระบบ",
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });
        setTimeout(() => {
          Swal.close();
          if (adminRole == 4) {
            router.push({ name: "certificate-approve" });
          } else {
            router.push({ name: "home" });
          }
        }, 1000);
      } else {
        Swal.fire({
          text: error,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "ลองใหม่ภายหลัง!",
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
      }
    };
    const onSubmitLoginThaID = async () => {
      await store.dispatch(Actions.LOGIN_THAI, formLogin.value);
      const [errorName] = Object.keys(store.getters.getErrors);
      const error = store.getters.getErrors[errorName];
      const adminRole = store.getters.currentUserAdminRole;
      if (!error) {
        Swal.fire({
          title: "กำลังเข้าสู่ระบบ",
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });
        setTimeout(() => {
          Swal.close();
          if (adminRole == 4) {
            router.push({ name: "certificate-approve" });
          } else {
            router.push({ name: "home" });
          }
        }, 1000);
      } else {
        Swal.fire({
          text: error,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "ลองใหม่ภายหลัง!",
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
      }
    };
    return {
      onSubmitLogin,
      login,
      submitButton,
      getGoogleUrl,
      getAccessToken,
      loginFacebook,
      rememberMe,
      initialValues,
      onCallBackLoginThaiID,
      getTokenThaiID,
      onSubmitLoginThaID,
      onCallBackLoginOIDC,
      getTokenOIDC,
    };
  },
  mounted() {
    // setTimeout(() => {
    //   const span: any = document.querySelector(".v-facebook-login span");
    //   console.log(span);
    //   if (span != null) {
    //     span.innerText = "เข้าสู่ระบบด้วยบัญชี Facebook";
    //   }
    // }, 20);
  },
  methods: {
    setText() {
      setTimeout(() => {
        const span: any = document.querySelector(".v-facebook-login span");
        // console.log(span);
        if (span != null) {
          span.innerText = "เข้าสู่ระบบด้วยบัญชี Facebook";
        }
      }, 20);
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    loginThaiD() {
      Swal.fire({
        text: "ระบบเข้าสู่ระบบด้วย ThaiD จะเปิดให้บริการเร็วๆ นี้",
        icon: "info",
        buttonsStyling: false,
        confirmButtonText: "ตกลง",
        customClass: {
          confirmButton: "btn fw-semobold btn-light-primary",
        },
      });
    },
  },
});
